import React from 'react';
import PermMediaOutlinedIcon from '@material-ui/icons/PermMediaOutlined';

export function PermMediaIcon() {
  return <PermMediaOutlinedIcon style={{marginRight: 2}} fontSize="small" />;
}
